import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutingPath } from '@app/core/Enum';
import { GlobalComponent } from '@app/core/Models/common/global-component';
import { GetListSavedFile } from '@app/core/Store';
import { Store } from '@ngxs/store';
import { NgxSpinnerService } from 'ngx-spinner';
export interface ReportElement {
  id: string;
  period: string;
  //desc: string;
  //type: string;
}

const ELEMENT_DATA: ReportElement[] = [
 
];

@Component({
  selector: 'app-submission-account-popup',
  templateUrl: './submission-account-popup.component.html',
  styleUrls: ['./submission-account-popup.component.scss']
})
export class SubmissionAccountPopupComponent implements OnInit {
  displayedAccountColumns: string[] = ['id', 'period'];
  dataAccountSource = ELEMENT_DATA;
  annualReportListSavedFiles: any[] = [];
  periodicDateList: any;
  accountingId: any;
  noDataFound = false;
  constructor(private spinner: NgxSpinnerService, public router: Router,private store: Store,private globalComponent: GlobalComponent) { }

  ngOnInit(): void {
    this.setPeriodDate();
  }

  setPeriodDate(): void {
    this.periodicDateList = this.globalComponent.getFinancialPeriod();

    const defaultPeriodName = localStorage.getItem('defaultFinancialPeriod');

    // CASE 1: Value exists in localStorage
    if (defaultPeriodName) {
      const foundPeriod = this.periodicDateList.find(
        (p) => p.name.trim() === defaultPeriodName.trim()
      );

      if (foundPeriod) {
        this.accountingId = foundPeriod.id;
      } else {
        this.accountingId = this.periodicDateList[0]?.id;
      }
    }
    // CASE 2: No value in localStorage
    else {
      this.accountingId = this.periodicDateList[0]?.id;
    }

    this.getListSavedFiles();
  }

  onPeriodChange(): void {
    const selected = this.periodicDateList.find(x => x.id === this.accountingId);
    if (selected) {
      localStorage.setItem('defaultFinancialPeriod', selected.name.trim());
    }

    this.getListSavedFiles();
  }

  getListSavedFiles(): void {
    this.spinner.show();
      this.store
        .dispatch(new GetListSavedFile(this.accountingId))
        .subscribe((res) => {
          if (res.annualReport.annualReportFileList.length > 0) {
            this.annualReportListSavedFiles = [];
            let selectedPeriodDetail = this.periodicDateList.filter(
              (x) => x.id === this.accountingId
            );
            let selectedDateRange = '';
            if (selectedPeriodDetail.length > 0) {
              selectedDateRange = selectedPeriodDetail[0].name.replace(/\s/g, '');
            }
            let list= res.annualReport.annualReportFileList.filter((element:any) =>element.isShowSubmit === true);
            list.forEach((element, i) => {
              const dataDisplay = {
                id: element.id,
                srno: i + 1,
                period: selectedDateRange,
                isShowSubmit:element.isShowSubmit
               // saveDate: element.savedDate,
               // saveTime: element.savedTime,
              };
              this.annualReportListSavedFiles.push(dataDisplay);   
            });
             this.noDataFound =this.annualReportListSavedFiles.length > 0 ? false : true;
            //this.dataSource.data = this.annualReportListSavedFiles;
            if(this.annualReportListSavedFiles.length){
                this.recordId=this.annualReportListSavedFiles[0]['id'];
            }
           
          } else {
           
            this.annualReportListSavedFiles = [];
            this.noDataFound = true;
          }
        });
    }
    recordId:any;
    radioChange(event: any) {
     this.recordId=event?.value

  }

  

  redirectToSubmit(): void{
    if(this.recordId && !this.noDataFound){
      this.router.navigate([RoutingPath.submitCompaniesHouse, { id: this.recordId,periodId:this.accountingId }]);
    }
  }
}
